import React from "react";
import { motion } from "framer-motion";

// Static motion props extracted once — avoids re-creating identical objects on
// every render, which prevents unnecessary child re-renders in framer-motion.
const CARD_INITIAL = { opacity: 0, y: 18 };
const CARD_ANIMATE = { opacity: 1, y: 0 };
const CARD_VIEWPORT = { once: true, amount: 0.2 };
const cardTransition = (i) => ({ duration: 0.55, delay: i * 0.08 });

const REVIEWS = [
  {
    name: "Camila Andrade",
    role: "Diretora de Marketing",
    company: "Grupo Vértix",
    quote:
      "A M NAIEF entregou nossas sacolas de algodão para o evento anual com ótima qualidade e prazo bem curto. O acabamento fez toda diferença.",
  },
  {
    name: "Rafael Monteiro",
    role: "Gerente de Endomarketing",
    company: "BRX Construtora",
    quote:
      "Atendimento consultivo, mockup preciso e produção dentro do combinado. Já é o terceiro projeto que fazemos — virou nosso fornecedor oficial de brindes corporativos.",
  },
  {
    name: "Juliana Prado",
    role: "Coordenadora de Eventos",
    company: "Mizu Hospitalidade",
    quote:
      "Squeezes e toalhas personalizadas que ficaram muito bonitos. Recebemos elogios de todos os convidados. Recomendo para qualquer empresa.",
  },
];

const STATS = [
  { value: "+500", label: "Projetos entregues" },
  { value: "98%", label: "Clientes satisfeitos" },
  { value: "+50", label: "Cidades atendidas" },
  { value: "7 dias", label: "Prazo médio" },
];

export const Testimonials = () => {
  return (
    <section id="depoimentos" data-testid="testimonials-section" className="mn-section bg-white">
      <div className="mn-container">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <span className="mn-eyebrow">Prova social</span>
            <h2 className="mn-h-display text-[2.25rem] sm:text-[2.5rem] lg:text-[2.75rem] mt-4 leading-tight">
              O que nossos clientes <span style={{ color: "var(--mn-gold)" }}>corporativos</span> dizem.
            </h2>
            <span className="mn-rule mt-7 mb-7" />
            <div className="grid grid-cols-2 gap-y-7 gap-x-4 mt-2" data-testid="stats-grid">
              {STATS.map((s) => (
                <div key={s.label} className="mn-stat">
                  <div className="font-serif-display text-[2rem] font-extrabold leading-none" style={{ color: "var(--mn-black)" }}>
                    {s.value}
                  </div>
                  <div className="text-xs uppercase tracking-[0.18em] text-[var(--mn-dark)] mt-2">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid md:grid-cols-2 gap-5" data-testid="testimonials-grid">
            {REVIEWS.map((r, i) => (
              <motion.figure
                key={r.name}
                initial={CARD_INITIAL}
                whileInView={CARD_ANIMATE}
                viewport={CARD_VIEWPORT}
                transition={cardTransition(i)}
                className={`border border-[var(--mn-line)] p-7 rounded-[4px] bg-white ${i === 2 ? "md:col-span-2" : ""}`}
                data-testid={`testimonial-${i}`}
              >
                <i className="fa-solid fa-quote-right text-2xl" style={{ color: "var(--mn-gold)" }} />
                <blockquote className="mt-4 font-serif-display text-[1.05rem] leading-relaxed text-[var(--mn-black)]">
                  {r.quote}
                </blockquote>
                <figcaption className="mt-6 flex items-center justify-between border-t border-[var(--mn-line)] pt-5">
                  <div>
                    <div className="font-bold text-sm text-[var(--mn-black)]">{r.name}</div>
                    <div className="text-xs text-[var(--mn-dark)] mt-1">
                      {r.role} — {r.company}
                    </div>
                  </div>
                  <div className="flex gap-1">
                    {Array.from({ length: 5 }).map((_, k) => (
                      <i key={`${r.name}-star-${k}`} className="fa-solid fa-star text-xs" style={{ color: "var(--mn-gold)" }} />
                    ))}
                  </div>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
